import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { apiAxios } from "../../../../utils/apiAxios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
const API_BASE = process.env.REACT_APP_API_BASE_URL;
const Phasewisededuction = () => {
 
  interface IPhaseMaster {
    phaseID: number;
    phaseCode: string;
    phaseName: string;
    isActive: boolean;
  }
  interface IPhaseWiseDeduction {
    deductionID?: number;
    phaseCode: string;
    phaseName: string;
    deductionType: string;
    deductionValue: number;
    allowCustomRefund: boolean;
    minRefundAmount: number;
    maxRefundAmount: number;
    isRefundable: boolean;
    isActive: boolean;
    sortOrder: number;
  }
  const [data, setData] = useState<IPhaseWiseDeduction[]>([]);
  const [loading, setLoading] = useState(false);
  const [phaseCode, setPhaseCode] = useState("");
  const [phases, setPhases] = useState<IPhaseMaster[]>([]);
  const [phaseName, setPhaseName] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [formData, setFormData] = useState<IPhaseWiseDeduction>({
    phaseCode: "",
    phaseName: "",
    deductionType: "",
    deductionValue: 0,
    allowCustomRefund: false,
    minRefundAmount: 0,
    maxRefundAmount: 0,
    isRefundable: false,
    isActive: true,
    sortOrder: 0,
  });
  const handleSave = async () => {
  // Validation
  if (!formData.phaseCode) {
    toast.error("Please select Phase Code");
    return;
  }

  if (!formData.phaseName) {
    toast.error("Phase Name is required");
    return;
  }

  if (!formData.deductionType) {
    toast.error("Please select Deduction Type");
    return;
  }

  if (formData.deductionValue <= 0) {
    toast.error("Deduction Value must be greater than 0");
    return;
  }

  if (
    formData.minRefundAmount > 0 &&
    formData.maxRefundAmount > 0 &&
    formData.minRefundAmount > formData.maxRefundAmount
  ) {
    toast.error("Min Refund cannot be greater than Max Refund");
    return;
  }

  try {
    let response;

    if (isEdit) {
      response = await apiAxios.put(
        `${API_BASE}/PhaseWiseDeduction/Update`,
        formData
      );
    } else {
      response = await apiAxios.post(
        `${API_BASE}/PhaseWiseDeduction/Create`,
        formData
      );
    }

    if (response.data?.isSuccess) {
      toast.success(
        isEdit
          ? "Record updated successfully"
          : "Record saved successfully"
      );

      fetchPhaseWiseDeductions();
      handleCancel();
      setIsEdit(false);
    } else {
      toast.error(response.data?.message || "Something went wrong");
    }
  } catch (error: any) {
    console.error(error);

    toast.error(
      error?.response?.data?.message ||
      "Failed to save record"
    );
  }
};
  const fetchPhases = async () => {
    try {
      const response = await apiAxios.get(`${API_BASE}/PhaseWiseDeduction/GetAllPhases`);
      if (response.data?.isSuccess) {
        setPhases(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching phases:", error);
    }
  };
  const fetchPhaseWiseDeductions = async () => {
    try {
      setLoading(true);
      const response = await apiAxios.get(`${API_BASE}/PhaseWiseDeduction/GetAll`);

      if (response.data?.isSuccess) {
        setData(response.data.singleData || []);
      }
    } catch (error) {
      console.error("Error fetching phase wise deductions:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPhaseWiseDeductions();
    fetchPhases();
  }, []);
  const handleCancel = () => {
    setFormData({
      phaseCode: "",
      phaseName: "",
      deductionType: "",
      deductionValue: 0,
      allowCustomRefund: false,
      minRefundAmount: 0,
      maxRefundAmount: 0,
      isRefundable: false,
      isActive: true,
      sortOrder: 0,
      
    });

  setPhaseCode("");
  setPhaseName("");
  setIsEdit(false);
  };
  const handleEdit = (row: IPhaseWiseDeduction) => {
    setIsEdit(true);

    setFormData({
      deductionID: row.deductionID,
      phaseCode: row.phaseCode,
      phaseName: row.phaseName,
      deductionType: row.deductionType,
      deductionValue: row.deductionValue,
      allowCustomRefund: row.allowCustomRefund,
      minRefundAmount: row.minRefundAmount,
      maxRefundAmount: row.maxRefundAmount,
      isRefundable: row.isRefundable,
      isActive: row.isActive,
      sortOrder: row.sortOrder,
    });
  };
  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      const response = await apiAxios.delete(
        `${API_BASE}/PhaseWiseDeduction/Delete/${deleteId}`
      );

      if (response.data?.isSuccess) {
        toast.success("Record deleted successfully");
        fetchPhaseWiseDeductions();
      }
    } catch (error: any) {
      toast.error("Delete failed");
    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  const EllipsisText = ({ text }: { text: string }) => (
  <div
    title={text}
    style={{
      maxWidth: "150px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {text}
  </div>
);
  const columns = [
    {
      name: "ID",
      selector: (row: any) => row.deductionID,
      width: "80px",
    },
   {
  name: "Phase Code",
  cell: (row: any) => (
    <EllipsisText text={row.phaseCode} />
  )
},
{
  name: "Phase Name",
  cell: (row: any) => (
    <EllipsisText text={row.phaseName} />
  )
},
{
  name: "Type",
  cell: (row: any) => (
    <EllipsisText text={row.deductionType} />
  )
},
    {
      name: "Value",
      selector: (row: any) => row.deductionValue,
      width: "100px",
    },
    {
      name: "Custom Refund",
      width: "140px",
      cell: (row: any) => (
        <span className={row.allowCustomRefund ? "text-success" : "text-danger"}>
          {row.allowCustomRefund ? "Yes" : "No"}
        </span>
      ),
    },
    {
      name: "Refundable",
      width: "130px",
      cell: (row: any) => (
        <span className={row.isRefundable ? "text-success" : "text-danger"}>
          {row.isRefundable ? "Yes" : "No"}
        </span>
      ),
    },
    {
      name: "Min Refund",
      selector: (row: any) => row.minRefundAmount,
      width: "120px",
    },
    {
      name: "Max Refund",
      selector: (row: any) => row.maxRefundAmount,
      width: "120px",
    },
    {
      name: "Sort Order",
      selector: (row: any) => row.sortOrder,
      width: "110px",
    },
    {
      name: "Status",
      width: "110px",
      cell: (row: any) => (
        <span
          className={`badge ${row.isActive ? "bg-success" : "bg-danger"
            }`}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      name: "Action",
      width: "120px",
      cell: (row: any) => (
        <div className="d-flex gap-2">
          <button
            className="action-btn delete"
            onClick={() => handleEdit(row)}
          >
            <i className="bi bi-pencil-square customdelete-icon"></i>
          </button>

          {row.isActive && (
            <button
              className="action-btn delete"
              onClick={() => {
                setDeleteId(row.deductionID);
                setShowDeleteModal(true);
              }}
            >
              <i className="bi bi-trash"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  const customStyles = {
    headRow: {
      style: {

        fontWeight: "600",
        fontSize: "13px",
        minHeight: "50px",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        minHeight: "45px",
      },
    },
  };

  return (
    <div className="container-fluid py-3">

      {/* ================= TITLE ================= */}
      <h4 className="mb-4">Phase Wise Deduction</h4>

      {/* ================= FORM ================= */}
      <div className="premium-card mt-2">
        {/* HEADER */}
        <div className="row g-3">

          {/* Row 1 */}


         <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Phase Code</label>

            <select
              className="form-select"
              value={formData.phaseCode}
              onChange={(e) => {
                const selectedCode = e.target.value;

                const selectedPhase = phases.find(
                  (x) => x.phaseCode === selectedCode
                );

                setFormData({
                  ...formData,
                  phaseCode: selectedCode,
                  phaseName: selectedPhase?.phaseName || "",
                });
              }}
            >
              <option value="">Select Phase Code</option>

              {phases.map((item) => (
                <option key={item.phaseID} value={item.phaseCode}>
                  {item.phaseCode}
                </option>
              ))}
            </select>
          </div>

         <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Phase Name</label>

            <input
              type="text"
              className="form-control"
              value={formData.phaseName}
              readOnly
            />
          </div>

       <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Deduction Type</label>

            <select
              className="form-select"
              value={formData.deductionType}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  deductionType: e.target.value,
                })
              }
            >
              <option value="">Select Type</option>
              <option value="PERCENTAGE">Percentage</option>
              <option value="CUSTOM">Custom</option>
              <option value="FIXED">Fixed Amount</option>
            </select>
          </div>

        <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Deduction Value</label>

            <input
              type="number"
              className="form-control form-control-sm"
              value={formData.deductionValue}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  deductionValue: Number(e.target.value),
                })
              }
            />
          </div>

          {/* Row 2 */}
          <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Min Refund</label>

            <input
              type="number"
              className="form-control form-control-sm"
              value={formData.minRefundAmount}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  minRefundAmount: Number(e.target.value),
                })
              }
            />
          </div>

       <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Max Refund</label>

            <input
              type="number"
              className="form-control form-control-sm"
              value={formData.maxRefundAmount}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  maxRefundAmount: Number(e.target.value),
                })
              }
            />
          </div>

        <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label">Sort Order</label>

            <input
              type="number"
              className="form-control form-control-sm"
              value={formData.sortOrder}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  sortOrder: Number(e.target.value),
                })
              }
            />
          </div>

          {/* Allow Custom Refund (Premium Toggle Card) */}
         <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label d-block">Allow Custom Refund</label>
            <div className="p-2 border rounded bg-light">



              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">Enable / Disable</small>

                <div className="form-check form-switch m-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={formData.allowCustomRefund}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        allowCustomRefund: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>

            </div>
          </div>

          {/* Is Refundable */}
           <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label d-block">Is Refundable</label>

            <div className="p-2 border rounded bg-light d-flex justify-content-between align-items-center">

              <small className="text-muted">Refund option</small>

              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={formData.isRefundable}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      isRefundable: e.target.checked,
                    })
                  }
                />
              </div>

            </div>
          </div>

          {/* Status */}
          <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label d-block">Status</label>

            <div className="p-2 border rounded bg-light d-flex justify-content-between align-items-center">

              <span className="text-muted small">Active / Inactive</span>

              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={formData.isActive}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      isActive: e.target.checked,
                    })
                  }
                />
              </div>

            </div>
          </div>

        </div>

        {/* ACTION BUTTONS */}
        <div className="mt-4 d-flex gap-2 py-2">
          <button
            type="button"
            className="btn btn-primary px-4"
            onClick={handleSave}
          >
            {isEdit ? "Update" : "Save"}
          </button>
          <button
            type="button"
            className="btn btn-secondary px-4"
            onClick={handleCancel}
          >
            Cancel
          </button>

        </div>
      </div>
      {/* ================= DATATABLE ================= */}
      <div className="premium-card mt-2">
        Deduction List
        <DataTable
          columns={columns}
          data={data}
          pagination
          responsive
          striped
          highlightOnHover
          customStyles={customStyles}
        />
      </div>
      {/* DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Body className="text-center">Are you sure you want to delete this PhaseDeduction?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            className="btn btn-danger"
            onClick={confirmDelete}
          >
            Delete
          </button>

          <button type="button" onClick={() => setShowDeleteModal(false)} className="btn py-2 px-3 btn-secondary mx-2">No</button>
        </Modal.Footer>
      </Modal>

    </div>


  );

};

export default Phasewisededuction;